import ProductSwatchesMobile from '@ulta/components/ProductSwatchesMobile/ProductSwatchesMobile';

export default ProductSwatchesMobile;